var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrifted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1083 0.5H4.89167L0.5 4.89167V11.1083L4.89167 15.5H11.1083L15.5 11.1083V4.89167L11.1083 0.5ZM13.8333 10.4167L10.4167 13.8333H5.58333L2.16667 10.4167V5.58333L5.58333 2.16667H10.4167L13.8333 5.58333V10.4167Z",
    fill: "#D59B16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 12.1667C8.46007 12.1667 8.83317 11.7936 8.83317 11.3333C8.83317 10.8731 8.46007 10.5 7.99984 10.5C7.5396 10.5 7.1665 10.8731 7.1665 11.3333C7.1665 11.7936 7.5396 12.1667 7.99984 12.1667Z",
    fill: "#D59B16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1665 3.83333H8.83317V9.66667H7.1665V3.83333Z",
    fill: "#D59B16"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrifted);
export default __webpack_public_path__ + "static/media/drifted.526f12f53425e6da40cc8f9409c95b77.svg";
export { ForwardRef as ReactComponent };